module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightIt.465f437.ttf";